/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Peryear1Inputs */

const en_peryear1 = /** @type {(inputs: Peryear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ year`)
};

const de_peryear1 = /** @type {(inputs: Peryear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ Jahr`)
};

/**
* | output |
* | --- |
* | "/ year" |
*
* @param {Peryear1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const peryear1 = /** @type {((inputs?: Peryear1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Peryear1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_peryear1(inputs)
	return de_peryear1(inputs)
});
export { peryear1 as "perYear" }